export default function loginTabsAndAjax() {

  const tabs = document.querySelectorAll('.tab-link');
  const contents = document.querySelectorAll('.tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');
    });
  });

  // LOGIN AJAX
  document.querySelector('#login-form')?.addEventListener('submit', function (e) {
    e.preventDefault();
    const formData = new FormData(this);
    const responseEl = this.querySelector('.form-response');
    responseEl.innerHTML = nlTheme.i18n.loggingIn;

    fetch(nlTheme.ajaxurl, {
      method: 'POST',
      body: formData,
    })
    .then(res => res.json())
    .then(json => {
      responseEl.innerHTML = json.data.message;
      if (json.success) {
        setTimeout(() => {
          if (document.body.classList.contains('single-collection')) {
            const cleanUrl = window.location.href.split('#')[0];
            history.replaceState(null, null, cleanUrl + '#private');
          }
          window.location.reload();
        }, 100);
      }
    });
  });

  // REGISTER AJAX
document.querySelector('#register-form')?.addEventListener('submit', function (e) {
  e.preventDefault();

  const formData = new FormData(this);
  const responseEl = this.querySelector('.form-response');
  responseEl.innerHTML = '';

  const password = formData.get('password');
  const password2 = formData.get('password2');

  if (password !== password2) {
    responseEl.innerHTML = nlTheme.i18n.passwordsDoNotMatch;
    return;
  }

  const requiredFields = ['name', 'email', 'password', 'position', 'company', 'country'];
  for (const field of requiredFields) {
    if (!formData.get(field)) {
      responseEl.innerHTML = `${nlTheme.i18n.pleaseFillAllFields} (${field})`;
      return;
    }
  }

  responseEl.innerHTML = nlTheme.i18n.registering;

  fetch(nlTheme.ajaxurl, {
    method: 'POST',
    body: formData,
  })
    .then(res => res.json())
    .then(json => {
      responseEl.innerHTML = json?.data?.message || nlTheme.i18n.somethingWentWrong;
    });
});


// FORGOT PASSWORD AJAX
document.querySelector('#forgot-form')?.addEventListener('submit', function (e) {
  e.preventDefault();
  const formData = new FormData(this);
  const responseEl = this.querySelector('.form-response');
  responseEl.innerHTML = nlTheme.i18n.sendingResetLink || 'Sending reset link...';

  fetch(nlTheme.ajaxurl, {
    method: 'POST',
    body: formData,
  })
    .then(res => res.json())
    .then(json => {
      responseEl.innerHTML = json?.data?.message || (nlTheme.i18n.somethingWentWrong || 'Something went wrong.');
    })
    .catch(err => {
      responseEl.innerHTML = nlTheme.i18n.updateError || 'Something went wrong. Please try again.';
      console.error('Fetch error:', err);
    });
});


document.querySelector('#account-update-form')?.addEventListener('submit', function (e) {
  e.preventDefault();
  const formData = new FormData(this);
  const responseEl = this.querySelector('.form-response');
  responseEl.innerHTML = nlTheme.i18n.updating;

  fetch(nlTheme.ajaxurl, {
    method: 'POST',
    body: formData,
  })
    .then(res => res.json())
    .then(json => {
      responseEl.innerHTML = json?.data?.message || nlTheme.i18n.unknownResponse;
      if (json.success && responseEl.innerHTML.includes('log in again')) {
        setTimeout(() => {
          window.location.href = nlTheme.homeurl+'#login';
        }, 1500);
      }
    })
      .catch(err => {
        responseEl.innerHTML = nlTheme.i18n.updateError;
        console.error('Fetch error:', err);
    });
});
}

